import { setIsToastOpen } from "../../slices/errorModal";
import { getTexts } from "../../../utils/texts";
var _getTexts = getTexts(),
  _getTexts$errorMessag = _getTexts.errorMessages,
  _getTexts$errorMessag2 = _getTexts$errorMessag.sentSessionExpired,
  sessionExpiredTitle = _getTexts$errorMessag2.sessionExpiredTitle,
  sessionExpiredMessage = _getTexts$errorMessag2.sessionExpiredMessage,
  sessionExpiredLink = _getTexts$errorMessag2.sessionExpiredLink,
  _getTexts$errorMessag3 = _getTexts$errorMessag.qrSessionExpired,
  qrSessionExpiredTitle = _getTexts$errorMessag3.qrSessionExpiredTitle,
  qrSessionExpiredMessage = _getTexts$errorMessag3.qrSessionExpiredMessage,
  qrSessionExpiredLink = _getTexts$errorMessag3.qrSessionExpiredLink,
  _getTexts$errorMessag4 = _getTexts$errorMessag.sessionBlocked,
  bannerTitle = _getTexts$errorMessag4.bannerTitle,
  bannerMessage = _getTexts$errorMessag4.bannerMessage;
export function handleToastMessage(dispatch, errorType) {
  switch (errorType) {
    case 'sent_session_expired':
      {
        dispatch(setIsToastOpen({
          isOpen: true,
          title: sessionExpiredTitle,
          message: sessionExpiredMessage,
          ctaText: sessionExpiredLink,
          ctaArg: '/'
        }));
        break;
      }
    case 'qr_session_expired':
      {
        dispatch(setIsToastOpen({
          isOpen: true,
          title: qrSessionExpiredTitle,
          message: qrSessionExpiredMessage,
          ctaText: qrSessionExpiredLink,
          ctaArg: '/'
        }));
        break;
      }
    case 'blocked':
      {
        dispatch(setIsToastOpen({
          isOpen: true,
          title: bannerTitle,
          message: bannerMessage
        }));
        break;
      }
  }
}
export function isValidRoute(route) {
  return ['/', 'factor_selector', 'mfa-by-email', 'qr', 'push_sent', 'signing_in', 'error', 'general_error', 'os_push_declined'].includes(route);
}